module.exports = __webpack_public_path__ + "img/RUS.db6a152d.svg";